import React, { ReactNode, useEffect } from 'react';
import { useGeneralHooks } from '../../Hooks/hooks';

interface IProps {
    children:ReactNode
};

const Provider:React.FC<IProps> = ({children}) => {
    const {currentUser,accessToken,navigate} = useGeneralHooks();
    useEffect(()=>{
        if(!accessToken || !currentUser){
            navigate('/')
        }
    },[accessToken,currentUser,navigate]);

  return (
    <>
      {children}
    </>
  )
}

export default Provider
